(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/divider-v4/assets/javascripts/divider.js') >= 0) return;  svs.modules.push('/modules/divider-v4/assets/javascripts/divider.js');
"use strict";


svs = svs || {};
svs.content = svs.content || {};
svs.content.divider = function () {
  const FOCUSABLE_SELECTOR = ['a[href]', 'area[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])', 'textarea:not([disabled])', 'iframe', 'audio[controls]', 'video[controls]', 'summary', '[contenteditable]:not([contenteditable="false"])', '[tabindex]:not([tabindex="-1"])'].join(',');
  const isVisible = el => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  const getFocusable = root => Array.from(root.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisible);
  const init = () => {
    const drawerEl = document.querySelector('.js-divider-drawer-login');
    const triggerEl = document.querySelector('.js-divider-hero-drawer-trigger');
    const closeBtn = document.querySelector('.js-divider-drawer-login-close-btn');
    const dimmerEl = document.querySelector('.js-divider-drawer-login-dimmer');
    const drawer = new svs.ui.Drawer({
      position: 'right',
      el: drawerEl,
      dimmerEl
    });
    let lastFocusedBeforeOpen = null;

    const originalClose = drawer.close.bind(drawer);
    drawer.close = function () {
      const result = originalClose(...arguments);
      releaseFocus();
      return result;
    };
    const handleKeydown = e => {
      if (e.key === 'Escape') {
        drawer.close();
        return;
      }
      if (e.key !== 'Tab') {
        return;
      }
      const focusable = getFocusable(drawerEl);
      if (focusable.length === 0) {
        e.preventDefault();
        drawerEl.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (e.shiftKey && (active === first || !drawerEl.contains(active))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (active === last || !drawerEl.contains(active))) {
        e.preventDefault();
        first.focus();
      }
    };
    const trapFocus = () => {
      lastFocusedBeforeOpen = document.activeElement;
      if (!drawerEl.hasAttribute('tabindex')) {
        drawerEl.setAttribute('tabindex', '-1');
      }
      requestAnimationFrame(() => {
        const focusable = getFocusable(drawerEl);
        (focusable[0] || drawerEl).focus();
      });
      document.addEventListener('keydown', handleKeydown, true);
    };
    const releaseFocus = () => {
      document.removeEventListener('keydown', handleKeydown, true);
      if (lastFocusedBeforeOpen && typeof lastFocusedBeforeOpen.focus === 'function') {
        lastFocusedBeforeOpen.focus();
      }
      lastFocusedBeforeOpen = null;
    };
    triggerEl.addEventListener('click', () => {
      drawer.open();
      trapFocus();
    });
    closeBtn.addEventListener('click', () => {
      drawer.close();
    });
  };
  return {
    init
  };
};

 })(window);